module.exports = __webpack_public_path__ + "img/employee-of-the-month.747db19e.jpg";